function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 274,
  cy: 274,
  r: 274,
  fill: "#0661A7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 274,
  cy: 274,
  r: 196,
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M451 270C451 369.964 369.964 451 270 451C170.036 451 89 369.964 89 270C89 170.036 170.036 89 270 89C290 261.5 451 170.036 451 270Z",
  fill: "#0072C6"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 300,
  cy: 246,
  r: 109,
  fill: "#0661A7"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 294,
  cy: 246,
  r: 75,
  fill: "#0661A7"
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 294,
  cy: 246,
  r: 60,
  fill: "#FFFFFE"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M413 289C413 373.5 344.5 442 260 442C175.5 442 107 373.5 107 289C107 204.501 175.5 136 260 136C267.921 136 275.351 119.738 283.04 103.001C309.5 96.0006 265.5 103.001 318 112.5C370.5 122 316.521 177.841 276 200.048C218.64 231.482 160.341 226.233 163.271 285.42C168.271 386.419 268.75 410.556 318 371C341.087 352.457 350.602 348.507 354.552 311.401C363.55 226.87 420.296 205.662 426.5 206.5C447.59 209.349 413 263.199 413 289Z",
  fill: "#C5C5C5"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M451 270C451 369.964 369.964 451 270 451C170.036 451 89 369.964 89 270C89 170.036 170.036 89 270 89C296.948 89 364.5 100 338.5 134.5C312.5 169 259 178 243 183.5C227 189 155.551 206.04 144 246C128.726 298.841 148 327.5 177.5 360.5C207 393.5 280.237 424.795 338.5 378C365.812 356.064 377.183 340.397 381.856 296.5C392.5 196.5 416.161 192.009 423.5 193C448.449 196.37 451 239.478 451 270Z",
  fill: "white"
});

var SvgC4D = function SvgC4D(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 548,
    height: 548,
    viewBox: "0 0 548 548",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgC4D, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/c4d.c3bafdb5.svg";
export { ForwardRef as ReactComponent };